<template>
  <modal name="private-note-modal"
         :width="`100%`"
         :height="610"
         :pivotX="0.5"
         :pivotY="0.5"
         :delay="100"
         :reset="true"
         @before-open="beforeOpen">
    <vue-scroll>
      <div
          class="FloatMenu md_overlay md_overlay_0"
          style="overflow: auto;"
      >
        <div
            class="modal modal_0"
        >
            <div class="md_content privateNoteModal">
              <div class="popup_title pb20">
                <h6 class="--blue70">{{ $t('private_note.name') }}</h6>
              </div>
              <div class="right_btn_container">
                <div
                    v-if="patientInfoProps.check && noteIndex === 0"
                    @click="changeNoteComponent(1)"
                    class="right_add_list_btn pointer right_btn"
                    style="margin-bottom:5px;"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
                       v-tooltip="{
                        content: this.$t('status.add'),
                        boundariesElement: this.window.document.body
                       }"
                       width="22" height="22"
                       viewBox="0 0 172 172"
                       style=" fill:#000000;">
                    <g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt"
                       stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0"
                       font-family="none" font-weight="none" font-size="none" text-anchor="none"
                       style="mix-blend-mode: normal">
                      <path d="M0,172v-172h172v172z" fill="none"></path>
                      <g id="original-icon" fill="#275cbb" opacity="0" visibility="hidden">
                        <path
                            d="M21.5,32.25c-5.93706,0 -10.75,4.81294 -10.75,10.75c0,5.93706 4.81294,10.75 10.75,10.75c5.93706,0 10.75,-4.81294 10.75,-10.75c0,-5.93706 -4.81294,-10.75 -10.75,-10.75zM57.33333,35.83333c-2.58456,-0.03655 -4.98858,1.32136 -6.29153,3.55376c-1.30295,2.2324 -1.30295,4.99342 0,7.22582c1.30295,2.2324 3.70697,3.59031 6.29153,3.55376h93.16667c2.58456,0.03655 4.98858,-1.32136 6.29153,-3.55376c1.30295,-2.2324 1.30295,-4.99342 0,-7.22582c-1.30295,-2.2324 -3.70697,-3.59031 -6.29153,-3.55376zM21.5,75.25c-5.93706,0 -10.75,4.81294 -10.75,10.75c0,5.93706 4.81294,10.75 10.75,10.75c5.93706,0 10.75,-4.81294 10.75,-10.75c0,-5.93706 -4.81294,-10.75 -10.75,-10.75zM57.33333,78.83333c-2.58456,-0.03655 -4.98858,1.32136 -6.29153,3.55376c-1.30295,2.2324 -1.30295,4.99342 0,7.22582c1.30295,2.2324 3.70697,3.59031 6.29153,3.55376h93.16667c2.58456,0.03655 4.98858,-1.32136 6.29153,-3.55376c1.30295,-2.2324 1.30295,-4.99342 0,-7.22582c-1.30295,-2.2324 -3.70697,-3.59031 -6.29153,-3.55376zM21.5,118.25c-5.93706,0 -10.75,4.81294 -10.75,10.75c0,5.93706 4.81294,10.75 10.75,10.75c5.93706,0 10.75,-4.81294 10.75,-10.75c0,-5.93706 -4.81294,-10.75 -10.75,-10.75zM57.33333,121.83333c-2.58456,-0.03655 -4.98858,1.32136 -6.29153,3.55376c-1.30295,2.2324 -1.30295,4.99342 0,7.22582c1.30295,2.2324 3.70697,3.59031 6.29153,3.55376h93.16667c2.58456,0.03655 4.98858,-1.32136 6.29153,-3.55376c1.30295,-2.2324 1.30295,-4.99342 0,-7.22582c-1.30295,-2.2324 -3.70697,-3.59031 -6.29153,-3.55376z"></path>
                      </g>
                      <g id="subtracted-icon" fill="#275cbb">
                        <path
                            d="M32.25,43c0,5.93706 -4.81294,10.75 -10.75,10.75c-5.93706,0 -10.75,-4.81294 -10.75,-10.75c0,-5.93706 4.81294,-10.75 10.75,-10.75c5.93706,0 10.75,4.81294 10.75,10.75zM150.5,35.83333c2.58456,-0.03655 4.98858,1.32136 6.29153,3.55376c1.30295,2.2324 1.30295,4.99342 0,7.22582c-1.30295,2.2324 -3.70697,3.59031 -6.29153,3.55376h-93.16667c-2.58456,0.03655 -4.98858,-1.32136 -6.29153,-3.55376c-1.30295,-2.2324 -1.30295,-4.99342 0,-7.22582c1.30295,-2.2324 3.70697,-3.59031 6.29153,-3.55376zM32.25,86c0,5.93706 -4.81294,10.75 -10.75,10.75c-5.93706,0 -10.75,-4.81294 -10.75,-10.75c0,-5.93706 4.81294,-10.75 10.75,-10.75c5.93706,0 10.75,4.81294 10.75,10.75zM150.5,78.83333c2.58456,-0.03655 4.98858,1.32136 6.29153,3.55376c1.30295,2.2324 1.30295,4.99342 0,7.22582c-0.12906,0.22112 -0.26892,0.43366 -0.41869,0.63712c-6.18476,-2.73207 -13.02143,-4.25003 -20.20617,-4.25003c-9.43612,0 -18.27186,2.61833 -25.81889,7.16667h-53.01445c-2.58456,0.03655 -4.98858,-1.32136 -6.29153,-3.55376c-1.30295,-2.2324 -1.30295,-4.99342 0,-7.22582c1.30295,-2.2324 3.70697,-3.59031 6.29153,-3.55376zM32.25,129c0,5.93706 -4.81294,10.75 -10.75,10.75c-5.93706,0 -10.75,-4.81294 -10.75,-10.75c0,-5.93706 4.81294,-10.75 10.75,-10.75c5.93706,0 10.75,4.81294 10.75,10.75zM57.33333,136.16667c-2.58456,0.03655 -4.98858,-1.32136 -6.29153,-3.55376c-1.30295,-2.2324 -1.30295,-4.99342 0,-7.22582c1.30295,-2.2324 3.70697,-3.59031 6.29153,-3.55376l30.7522,0c-1.35665,4.54325 -2.08553,9.35473 -2.08553,14.33333z"></path>
                      </g>
                      <g>
                        <g id="Layer_1" fill="#275cbb">
                          <path
                              d="M136.16667,100.33333c-19.78717,0 -35.83333,16.04617 -35.83333,35.83333c0,19.78717 16.04617,35.83333 35.83333,35.83333c19.78717,0 35.83333,-16.04617 35.83333,-35.83333c0,-19.78717 -16.04617,-35.83333 -35.83333,-35.83333zM150.5,143.33333h-7.16667v7.16667c0,3.956 -3.21067,7.16667 -7.16667,7.16667c-3.956,0 -7.16667,-3.21067 -7.16667,-7.16667v-7.16667h-7.16667c-3.956,0 -7.16667,-3.21067 -7.16667,-7.16667c0,-3.956 3.21067,-7.16667 7.16667,-7.16667h7.16667v-7.16667c0,-3.956 3.21067,-7.16667 7.16667,-7.16667c3.956,0 7.16667,3.21067 7.16667,7.16667v7.16667h7.16667c3.956,0 7.16667,3.21067 7.16667,7.16667c0,3.956 -3.21067,7.16667 -7.16667,7.16667z"></path>
                        </g>
                        <g id="Rounded" fill="#000000" opacity="0">
                          <path
                              d="M86,136.16667c0,-27.66333 22.50333,-50.16667 50.16667,-50.16667c27.66333,0 50.16667,22.50333 50.16667,50.16667c0,27.66333 -22.50333,50.16667 -50.16667,50.16667c-27.66333,0 -50.16667,-22.50333 -50.16667,-50.16667z"></path>
                        </g>
                      </g>
                    </g>
                  </svg>
                </div>
                <div
                    v-if="patientInfoProps.check && noteIndex === 2"
                    @click="changeNoteComponent(1, selectedIdx)"
                    class="right_edit_btn pointer right_btn"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
                       v-tooltip="{
                        content: this.$t('status.edit'),
                        boundariesElement: this.window.document.body
                       }"
                       width="22" height="22"
                       viewBox="0 0 172 172"
                       style=" fill:#b1b1b1;">
                    <g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt"
                       stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0"
                       font-family="none" font-weight="none" font-size="none" text-anchor="none"
                       style="mix-blend-mode: normal">
                      <path d="M0,172v-172h172v172z" fill="none"></path>
                      <g fill="#275cbb">
                        <path
                            d="M43,14.33333c-7.88333,0 -14.33333,6.45 -14.33333,14.33333v114.66667c0,7.88333 6.45,14.33333 14.33333,14.33333h80.0651l-14.33333,-14.33333h-65.73177v-114.66667h50.16667v35.83333h35.83333v29.89844l14.33333,14.33333v-51.39844l-43,-43zM107.5,107.5v14.33333l36.88314,36.88314l14.33333,-14.33333l-36.88314,-36.88314zM163.78353,149.4502l-14.33333,14.33333l7.16667,7.16667c1.3975,1.3975 3.66956,1.3975 5.06706,0l9.26628,-9.26628c1.3975,-1.40467 1.3975,-3.66956 0,-5.06706z"></path>
                      </g>
                    </g>
                  </svg>
                </div>
                <div
                    v-if="patientInfoProps.check && noteIndex === 2"
                    class="right_delete_btn pointer right_btn"
                    @click="$modal.show('yes-or-no-modal', {questionType:'delete', function: deleteNote})"
                    style="margin: 0 4px 0 0;"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
                       v-tooltip="{
                        content: this.$t('status.delete'),
                        boundariesElement: this.window.document.body
                       }"
                       width="21" height="21"
                       viewBox="0 0 172 172"
                       style=" fill:#000000;">
                    <g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt"
                       stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0"
                       font-family="none" font-weight="none" font-size="none" text-anchor="none"
                       style="mix-blend-mode: normal">
                      <path d="M0,172v-172h172v172z" fill="none"></path>
                      <g fill="#275cbb">
                        <path
                            d="M71.66667,14.33333l-7.16667,7.16667h-35.83333v14.33333h7.16667v107.5c0,7.83362 6.49972,14.33333 14.33333,14.33333h57.33333v-14.33333h-57.33333v-107.5h71.66667v71.66667h14.33333v-71.66667h7.16667v-14.33333h-7.16667h-28.66667l-7.16667,-7.16667zM64.5,50.16667v78.83333h14.33333v-78.83333zM93.16667,50.16667v78.83333h14.33333v-78.83333zM128.13216,121.32943l-10.13411,10.13411l15.20117,15.20117l-15.20117,15.20117l10.13411,10.13411l15.20117,-15.20117l15.20117,15.20117l10.13411,-10.13411l-15.20117,-15.20117l15.20117,-15.20117l-10.13411,-10.13411l-15.20117,15.20117z"></path>
                      </g>
                    </g>
                  </svg>
                </div>
                <div
                    v-if="patientInfoProps.check && noteIndex === 1"
                    @click="validationCheck"
                    class="right_save_btn pointer right_btn"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
                       v-tooltip="{
                        content: this.$t('status.save'),
                        boundariesElement: this.window.document.body
                       }"
                       width="22" height="22"
                       viewBox="0 0 172 172"
                       style=" fill:#000000;">
                    <g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt"
                       stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0"
                       font-family="none" font-weight="none" font-size="none" text-anchor="none"
                       style="mix-blend-mode: normal">
                      <path d="M0,172v-172h172v172z" fill="none"></path>
                      <g fill="#275cbb">
                        <path
                            d="M34.4,22.93333c-6.33533,0 -11.46667,5.13133 -11.46667,11.46667v103.2c0,6.33533 5.13133,11.46667 11.46667,11.46667h103.2c6.33533,0 11.46667,-5.13133 11.46667,-11.46667v-91.73333l-22.93333,-22.93333h-11.46667v34.4c0,3.1648 -2.56853,5.73333 -5.73333,5.73333h-51.6c-3.1648,0 -5.73333,-2.56853 -5.73333,-5.73333v-34.4zM91.73333,22.93333v28.66667h11.46667v-28.66667zM57.33333,91.73333h57.33333c6.33533,0 11.46667,5.13133 11.46667,11.46667v34.4h-80.26667v-34.4c0,-6.33533 5.13133,-11.46667 11.46667,-11.46667z"></path>
                      </g>
                    </g>
                  </svg>
                </div>
                <div
                    @click="changeNoteComponent(0)"
                    v-if="noteIndex === 2 || noteIndex === 1"
                    class="right_cancel_btn pointer right_btn"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
                       v-tooltip="{
                        content: this.$t('status.cancel'),
                        boundariesElement: this.window.document.body
                       }"
                       width="19" height="19"
                       viewBox="0 0 172 172"
                       style=" fill:#000000; margin-top:1px;">
                    <g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt"
                       stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0"
                       font-family="none" font-weight="none" font-size="none" text-anchor="none"
                       style="mix-blend-mode: normal">
                      <path d="M0,172v-172h172v172z" fill="none"></path>
                      <g id="original-icon" fill="#275cbb">
                        <path
                            d="M50.16667,13.4375l-50.16667,36.72917l50.16667,36.72917v-22.39583h57.33333c19.96028,0 35.83333,15.87305 35.83333,35.83333c0,19.96028 -15.87305,35.83333 -35.83333,35.83333h-107.5v28.66667h107.5c35.44141,0 64.5,-29.05859 64.5,-64.5c0,-35.4414 -29.05859,-64.5 -64.5,-64.5h-57.33333z"></path>
                      </g>
                    </g>
                  </svg>
                </div>
              </div>
              <span class="md_close">
              <img src="/images/union.svg"
                   alt=""
                   @click="modalClose"
              />
            </span>
              <component
                  ref="NoteComponent"
                  v-bind:is="PrivateNoteComponents"
                  :notes="noteLists"
                  :pageInfo="pageInfo"
                  :selectedIdx="selectedIdx"
                  :seqMedicalRelation="patientInfoProps.patientInfo.seqMedicalRelation"
                  @changeNoteComponent="changeNoteComponent"
                  @changeNoteListPage="getNoteListFromServerByLimit"
              />
            </div>
        </div>
      </div>
    </vue-scroll>
  </modal>

</template>

<script>
import PrivateNoteList from '@/components/body/myPatient/note/list'
import PrivateNoteView from '@/components/body/myPatient/note/view'
import PrivateNoteWrite from '@/components/body/myPatient/note/write'
import _API from "../../../api";

export default {
  name: 'PrivateNoteModal',
  components: {
    PrivateNoteList, PrivateNoteView, PrivateNoteWrite,
  },
  props: [
      'patientInfoProps',
  ],
  data() {
    let data = {};
    data = Object.assign({}, data, this.patientInfoProps);
    return {
      PrivateNoteComponents: `PrivateNoteList`,
      patientData: data,
      noteIndex: 0,
      componentName: {
        0: `PrivateNoteList`,
        1: `PrivateNoteWrite`,
        2: `PrivateNoteView`,
      },
      noteLists: [],
      pageInfo: {
        size: 10,//고정된 값입니다.
        currentPage: 0,//조회시마다 돌아오는 currentPage 값. 검색시 size*currentPage를 하면 다음 검색 start index가 나옴.
      },
      selectedIdx: 0,
      window: window
    }
  },
  methods: {
    changeNoteComponent(noteIdx, idx = undefined) {
      this.PrivateNoteComponents = this.componentName[noteIdx];
      this.selectedIdx = idx;
      this.noteIndex = noteIdx;
    },
    getNoteListFromServerByLimit(currentPage = null, done = () => {/*This is intentional*/
    }) {
      return new Promise((_resolve, reject) => {
        if (currentPage !== null) {
          this.pageInfo.currentPage = currentPage;
        }
        _API.PATIENT_PUBLIC_NOTE.getPatientPublicNoteListByLimit(
            this.patientInfoProps.patientInfo.seqMedicalRelation, this.pageInfo.currentPage, false,
            this.pageInfo.size)
            .then(res => {
              if (res.data.isSuccess && res.data.managerNoteList.length > 0) {
                for (let resData of res?.data?.managerNoteList)
                  this.noteLists.push(resData);

                this.pageInfo.currentPage += res.data.managerNoteList.length;
                done(true);
              } else {
                //분기처리를 할것.
                //날 수 있는 오류는 더 추가될 수 있으나, 우선은 쓴 글이 없다. 가 있습니다.
                //그럴경우 errorCode = 1 이 될것으로 합시다.
                if (res.data.failedCode === 1) {
                  //게시판에 글이 없다는 내용을 채울 부분
                  done(false, 1);
                } else {
                  //우리가 예측하지 못한 오류인 경우
                  done(false, 2, `[getNoteListFromServerByLimit] unresolved error`);
                }
              }
            })
            .catch(e => {
              reject({errorCode: 3, error: `[getNoteListFromServerByLimit] ${e}`});
            });
      });
    },
    validationCheck() {
      const noteData = this.$refs.NoteComponent.getValue();
      if (noteData.noteTitle === '' || noteData.noteContent === '') {
        this.$modal.show('common-alert-modal', {
          messageType: 'short',
          message: 'account.please_input_everything'
        });
        return;
      }
      this.$modal.show('yes-or-no-modal', {questionType: 'save', function: this.writeNote});
    },
    writeNote() {
      const noteData = this.$refs.NoteComponent.getValue();
      if (this.selectedIdx !== undefined) { 	// Edit the note
        return new Promise((resolve, reject) => {
          _API.PATIENT_PUBLIC_NOTE.updatePatientPublicNote(noteData, false)
              .then(res => {
                if (res.data.isSuccess) {
                  this.noteLists[this.selectedIdx].noteTitle = noteData.noteTitle;
                  this.noteLists[this.selectedIdx].noteContent = noteData.noteContent;
                  this.changeNoteComponent(0);
                  this.$modal.show('common-alert-modal', {
                    messageType: 'short',
                    message: 'alert.save_completed'
                  });
                  resolve();
                } else {
                  reject('[writeNote] Editing note is failed');
                }
              })
              .catch(e => {
                reject(`[writeNote] ${e}`);
              });
        });
      } else { 	// Write a new note
        return new Promise((resolve, reject) => {
          _API.PATIENT_PUBLIC_NOTE.insertPatientPublicNote(noteData, false)
              .then(res => {
                if (res.data.isSuccess) {
                  noteData.seqManagerNote = res.data.insertId;
                  this.noteLists.push(noteData);
                  this.changeNoteComponent(0);
                  this.$modal.show('common-alert-modal', {
                    messageType: 'short',
                    message: 'alert.save_completed'
                  });
                  this.pageInfo.currentPage += 1;
                  resolve();
                } else {
                  reject('[writeNote] Writing a note is failed');
                }
              })
              .catch(e => {
                reject(`[writeNote] ${e}`);
              });
        });
      }
    },
    deleteNote() {
      if (typeof this.selectedIdx !== "number") {
        throw new Error(`wrong approach`);
      }

      const seqManagerNote = this.noteLists[this.selectedIdx].seqManagerNote;
      return new Promise((resolve, reject) => {
        _API.PATIENT_PUBLIC_NOTE.deletePublicNote(seqManagerNote)
            .then(res => {
              if (res.data.isSuccess) {
                this.noteLists.removeItemByKeyMatch(`seqManagerNote`, seqManagerNote);
                this.changeNoteComponent(0);
                this.$modal.show('common-alert-modal', {
                  messageType: 'short',
                  message: 'alert.delete_completed'
                });
                resolve();
              } else {
                reject('[deleteNote] deleteNote failed');
              }
            })
            .catch(e => {
              reject(`[deleteNote] ${e}`);
            })
      });
    },
    modalClose: function (event) {
      this.$modal.hide('private-note-modal');
      event?.stopPropagation();
      event?.preventDefault();
    },
    beforeOpen() {
      // 첫 화면 집입은 무조건 리스트
      this.PrivateNoteComponents = `PrivateNoteList`;
      this.noteIndex = 0;
    }
  },
  watch: {
    patientInfoProps: {
      deep: true,
      handler(newVal, oldVal) {
        if (newVal.seqPatient !== oldVal.seqPatient) {
          this.noteLists = [];
          this.pageInfo.currentPage = 0;
        }
      }
    }
  }
}
</script>
<style lang="scss">

.v--modal-overlay[data-modal="private-note-modal"] {
  .modal {
    overflow-x: scroll;
    width: 820px;
    margin: 0 auto;

    .privateNoteModal {
      .right_btn_container {
        margin: 0;
      }

      .note_list_mt20 {
        .ListTable {
          .table-container {
            .item-parent {
              margin: 0;

              .item {
                padding: 1rem .3rem;
                max-width: 500px;
              }

              .item:nth-child(1) {
                display: none;
              }
            }
          }
        }
      }

      .bottom_btn {

        a {
          margin-top: 20px;
          margin-left: 10px;
          width: 200px !important;
          display: inline-block !important;
          float: right !important;

          &.deleteBtn {
            background-color: var(--warning20);
            color: var(--white);
          }
        }
      }
    }
  }
}
</style>